// Import necessary modules from Firebase v9+ (modular SDK)
import { initializeApp } from "firebase/app";
import {
  getMessaging,
  getToken,
  onMessage,
  deleteToken
} from "firebase/messaging";

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCzZ_-Op7rdoRVznRHmafTzmQMP_FhehXI",
  authDomain: "mst-validator-1df41.firebaseapp.com",
  projectId: "mst-validator-1df41",
  storageBucket: "mst-validator-1df41.firebasestorage.app",
  messagingSenderId: "445659976769",
  appId: "1:445659976769:web:0b43ded1dc6a3b6ba262c0",
  measurementId: "G-SN64WZJ7YZ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

const publicKey = process.env.REACT_APP_VAPID_KEY;

export const getFCMToken = async (setTokenFound) => {
  let currentToken = "";
  try {
    currentToken = await getToken(messaging, { vapidKey: publicKey });
    if (currentToken) {
      setTokenFound(true);
    } else {
      setTokenFound(false);
    }
  } catch (error) {
    console.log("An error occurred while retrieving token.", error);
  }
  return currentToken;
};

export const onMessageListener = (setNotification) =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      setNotification({
        title: payload.notification.title,
        body: payload.notification.body,
        messageId: payload.messageId
      });
      resolve(payload);
    });
  });

export { messaging, getToken, deleteToken };
